import { createAsyncAction } from 'typesafe-actions';
import * as types from './sales.actionTypes';

export const fetchSiteSalesTargetAsync = createAsyncAction(
  types.FETCH_USER_SALES_REQUEST,
  types.FETCH_USER_SALES_SUCCESS,
  types.FETCH_USER_SALES_FAILURE
)<string, { completed: number; salesTargetTotal: number; salesTargetToDate: number }, { error: string }>();
